import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from "vue";
  import BuilderEstimatorSummaryDesignForm from "./BuilderEstimatorSummaryDesignForm.vue";
  import BuilderEstimatorSummarySuccessMessage from "./BuilderEstimatorSummarySuccessMessage.vue";
  import { IBuilderEstimatorFormData } from "@/types/BuilderEstimatorFormData";
  import { FormSummaryType } from "@/enums/FormSummaryType";
  import { SummaryUserSelectionFormData } from "@/types/BuilderEstimatorMapper";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderEstimatorSummarySidebar',
  props: {
    builderLogo: {},
    userSelectedOptions: {},
    totalPrice: {},
    isLoading: { type: Boolean },
    showSuccessMessage: { type: Boolean }
  },
  emits: ["select-prev", "on-submit"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emit = __emit;

  const isFormOpen = ref<boolean>(false);
  const submitSuccessful = ref<boolean>(false);
  const formTypeSelected = ref<FormSummaryType | null>(null);

  const onSelectPrev = () => {
    if (isFormOpen.value) {
      isFormOpen.value = false;
    } else {
      emit("select-prev");
      window.scrollTo(0, 0);
    }
  };

  const onGetFreeDesign = () => {
    formTypeSelected.value = FormSummaryType.FREE_DESIGN;
    isFormOpen.value = true;
    window.scrollTo(0, 0);
  };

  const onBookConsultation = () => {
    formTypeSelected.value = FormSummaryType.CONSULTATION;
    isFormOpen.value = true;
    window.scrollTo(0, 0);
  };

  const onFormSubmit = async (formData: {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
  }) => {
    if (!formTypeSelected.value) return;

    emit("on-submit", {
      userSelectedOptions: props.userSelectedOptions,
      ...formData,
      totalPrice: props.totalPrice,
      formSummaryType: formTypeSelected.value,
    });
    submitSuccessful.value = true;
  };

  const resetForm = () => {
    isFormOpen.value = false;
    submitSuccessful.value = false;
  };
  const canShowSuccessMessage = computed(() => {
    if (props.showSuccessMessage && submitSuccessful.value) return true;

    return false;
  });

const __returned__ = { props, emit, isFormOpen, submitSuccessful, formTypeSelected, onSelectPrev, onGetFreeDesign, onBookConsultation, onFormSubmit, resetForm, canShowSuccessMessage, computed, onMounted, ref, BuilderEstimatorSummaryDesignForm, BuilderEstimatorSummarySuccessMessage, get IBuilderEstimatorFormData() { return IBuilderEstimatorFormData }, get FormSummaryType() { return FormSummaryType }, get SummaryUserSelectionFormData() { return SummaryUserSelectionFormData } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})